import React from 'react'
import PropTypes from 'prop-types'

class HoverableItem extends React.PureComponent{

  static propTypes = {
    style: PropTypes.shape(),
    id: PropTypes.string,
    item: PropTypes.shape(),
    onPress: PropTypes.func,
    children: PropTypes.shape()
  }

  constructor(props){
    super(props)
    this.state = {
      highlighted: false
    }
  }

  onMouseEnter = () => this.setState({ highlighted: true })

  onMouseLeave = () => this.setState({ highlighted: false })

  render(){
    const { id, item, onPress, style } = this.props
    return (
      <div
        style={{
          ...styles.container,
          ...style,
          ...styles.highlight(this.state.highlighted)
        }}
        key={id}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={() => onPress(item)}>
        {this.props.children}
      </div>
    )
  }
}

export default HoverableItem

const styles = {
  highlight: (execute) => {
    if (execute){
      return {backgroundColor: 'rgba(217, 217, 217, 0.4)'}
    } else {
      return {}
    }
  },
  container: {
    color: '#494949',
    fontSize: 14,
    cursor: 'pointer'
  }
}



// WEBPACK FOOTER //
// ./src/customer/common/HoverableItem.js